import script from "./PlaqueCondition.vue?vue&type=script&lang=ts&setup=true"
export * from "./PlaqueCondition.vue?vue&type=script&lang=ts&setup=true"

import "./PlaqueCondition.vue?vue&type=style&index=0&id=d179a25a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d179a25a"]])

export default __exports__